import { StrictMode } from "react"
import "remixicon/fonts/remixicon.css"
import "./i18n"
import { createRoot } from "react-dom/client"
import "./index.css"
import App from "@/app/App.tsx"

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
